import client from './client';
import type { ApiResponse, User, UserPreferences } from '@/types';

export const authApi = {
  async register(data: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
  }): Promise<ApiResponse<User>> {
    const response = await client.post('/auth/register', data);
    return response.data;
  },

  async login(data: {
    email: string;
    password: string;
    mfaToken?: string;
  }): Promise<ApiResponse<{ user: User; token: string }>> {
    const response = await client.post('/auth/login', data);
    return response.data;
  },

  async getCurrentUser(): Promise<ApiResponse<User>> {
    const response = await client.get('/auth/me');
    return response.data;
  },

  async enableMFA(): Promise<ApiResponse<{ secret: string; qrCode: string }>> {
    const response = await client.post('/auth/mfa/enable');
    return response.data;
  },

  async verifyMFA(token: string): Promise<ApiResponse> {
    const response = await client.post('/auth/mfa/verify', { token });
    return response.data;
  },

  async disableMFA(token: string): Promise<ApiResponse> {
    const response = await client.post('/auth/mfa/disable', { token });
    return response.data;
  },

  async switchRole(roleId: string): Promise<ApiResponse> {
    const response = await client.post('/auth/switch-role', { roleId });
    return response.data;
  },

  async getSSOStatus(): Promise<ApiResponse<{ enabled: boolean }>> {
    const response = await client.get('/auth/sso/status');
    return response.data;
  },

  async updateProfile(data: {
    firstName?: string;
    lastName?: string;
    preferences?: UserPreferences;
  }): Promise<ApiResponse<User>> {
    const response = await client.patch('/auth/me', data);
    return response.data;
  },

  async changePassword(data: {
    currentPassword: string;
    newPassword: string;
  }): Promise<ApiResponse> {
    const response = await client.post('/auth/change-password', data);
    return response.data;
  },
};
